import { Grid, Typography } from '@mui/material';

type FontDemoProps = {
  font: string;
};

export default function FontDemo({ font }: FontDemoProps) {
  return (
    <Grid size={{ xs: 12, md: 6 }}>
      <Typography fontFamily={font} fontWeight="bold">
        The quick brown fox jumps over the lazy dogs
      </Typography>
      <Typography mb={2} fontFamily={font}>
        The quick brown fox jumps over the lazy dogs
      </Typography>
      <Typography fontFamily={font} textTransform="uppercase" fontWeight="bold">
        The quick brown fox jumps over the lazy dogs
      </Typography>
      <Typography mb={2} fontFamily={font} textTransform="uppercase">
        The quick brown fox jumps over the lazy dogs
      </Typography>
      <Typography fontFamily={font} fontWeight="bold">
        $100,000.00
      </Typography>
      <Typography fontFamily={font}>$100,000.00</Typography>
    </Grid>
  );
}
